var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getUserType == 0)?_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"main-container__current-component"},[_c('ViewAll')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }